import { FileHelper, ProgressData } from '@helloself/hello-self-ui';
import { Storage } from 'aws-amplify';

import { Api as API } from '../../config/apiCallDispatcher';
import { storageConfig } from '../configureStorage';
import { FilePreviewResponse, GetByUUIDResponse, UploadAttachmentResponse } from './types';

export type Entity = {
    entityType: string;
    entityId: string;
};

export const uploadAttachment = async (
    fromUserId: string,
    entityType: string,
    fileName: string,
    file: Blob,
    attachTo?: Entity,
    progressCallback?: (progress?: ProgressData) => void
) => {
    // Before any bytes leave: a file FileStore would refuse fails here with a sentence the partner can act on.
    FileHelper.assertFileStoreAccepts({ name: fileName, size: file.size });
    await Storage.put(fileName, file, {
        level: 'private',
        contentType: file.type,
        bucket: storageConfig.STORAGE_UPLOAD,
        progressCallback: ({ loaded, total }: { loaded: number; total: number }) => {
            progressCallback?.({ loaded, total });
        },
    });

    const response = await API.post('files', 'v1/upload', {
        s3Key: `private/eu-west-1:${fromUserId}/${fileName}`,
        entityType,
        attachTo,
    });

    return response.data as UploadAttachmentResponse;
};

export const getFileByUUID = async (uuids: string[]) => {
    const response = await API.post('files', 'v1/sign-uuid', {
        uuids,
    });

    return response.data as GetByUUIDResponse;
};

export const getSignedURL = async (filename: string): Promise<string> => {
    const signedUrl = (await Storage.get(filename, {
        level: 'private',
        download: false,
        expires: 600,
    })) as string;
    return signedUrl;
};

export const fetchFilePreview = async (url: string, width = 100, height = 100) => {
    /** url should be an unsigned preview url  */
    const response = await API.post('files', 'v1/preview', {
        signedObjectRequest: url,
        width: width || 100,
        height: height || 100,
    });

    return response.data as FilePreviewResponse;
};
